// Generated by purs version 0.15.15
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Programs_Controllers_DocumentSelection from "../Ouroboros.Programs.Controllers.DocumentSelection/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
var readState = function (v) {
    return v;
};
var mkDocumentSelectionEnv = function (input) {
    return {
        loading: input.kernel.loading,
        lifecycle: input.kernel.lifecycle,
        navigate: input.kernel.navigate,
        reviewRoute: input.kernel.reviewRoute,
        document: input.kernel.document,
        availableDocuments: input.kernel.availableDocuments,
        downloadDocument: input.kernel.downloadDocument,
        taskRunner: input.kernel.taskRunner,
        documentCreationRoute: input.documentCreationRoute
    };
};
var buildDocumentSelectionViewProps = function (input) {
    var controller = Ouroboros_Programs_Controllers_DocumentSelection.mkDocumentSelectionController(mkDocumentSelectionEnv(input));
    return {
        availableDocuments: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.availableDocuments)),
        onCreateDocument: function (v) {
            return Ouroboros_Programs_Controllers_DocumentSelection.runDocumentSelectionAction(controller.onCreateDocument);
        },
        onSelectDocument: function (documentId) {
            return Ouroboros_Programs_Controllers_DocumentSelection.runDocumentSelectionAction(controller.onSelectDocument(documentId));
        },
        onDownloadDocument: function (payload) {
            return Ouroboros_Programs_Controllers_DocumentSelection.runDocumentSelectionAction(controller.onDownloadDocument(payload));
        },
        onDeleteDocument: function (documentId) {
            return Ouroboros_Programs_Controllers_DocumentSelection.runDocumentSelectionAction(controller.onDeleteDocument(documentId));
        },
        onInit: Ouroboros_Services_Clients_Interop_Option.some(Ouroboros_Programs_Controllers_DocumentSelection.runDocumentSelectionAction(controller.onInit))
    };
};
export {
    buildDocumentSelectionViewProps
};
//# sourceMappingURL=index.js.map
